// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_yngAo {
  display: flex;
  padding: 12px 14px;
  font-family: "Inter", sans-serif;
  background-color: var(--f6-background);
  height: 80vh;
  width: 80%;
  max-width: 800px;
  justify-content: space-between;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: scroll;
  box-shadow: 0 4px 8px var(--_0000001a-shadow); 
  border-radius: 8px; 
  z-index: 999;
  gap: 20px;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  box-sizing: border-box;
  flex-direction: column;
  overflow: hidden;
}

.HeaderUserSetting_yfD9t {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .headerLeft_AvIqO {
    display: flex;
    align-items: center;
    gap: 10px;
    text-transform: capitalize;
    font-size: 20px;
    font-weight: 600;
  }

  .arrowGreen_obSOR {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    padding: 4px;
    cursor: pointer;
    background-color: var(--_16c098-color);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
  }

  .arrowHeaderGray_Q3wSX {
    height: 10px;
    width: 10px;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
  }
}

.container_yngAo::-webkit-scrollbar {
  display: none; 
}
.leftSection_lb85o {
  width: 30%;
  height: fit-content;
}

.breadcrumb_BI21A {
  font-size: 14px;
  color: #484848;
  margin-bottom: 29px;
  font-weight: 600;
  gap: 20px;
  display: flex;
  align-items: center;
  svg {
    color: #767676;
    font-size: 10px;
    width: 10px;
    span {
      cursor: pointer;
      -webkit-user-select: none;
              user-select: none;
    }
  }
}

.detailsContainer_trL5e {
  margin-bottom: 24px;
}

.detailItem_NN4B4 {
  border-bottom: 1px solid #ebebeb;
  padding: 12px 0px 12px;
}




.editButton_DJR9F,
.addButton_thnAO {
  font-size: 12px;
  color: var(--_16c098-color);
  background: none;
  border: none;
  cursor: pointer;
}





.rightSection_NE3fW {
  margin-bottom: 40px;
  overflow-y: scroll;
  overflow-x: hidden;
  flex: 2 1;
  width: 100%;
  background-color: var(--white-color);
  padding: 15px;
  padding-top: 0;
  box-sizing: border-box;
  border: 1px solid var(--ececf1-border);
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
}

.faqContainer_bLtN9 {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  box-sizing: border-box;
}

.faqItem_D9e_D {
  flex: 0.35 1;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #dddddd;
  padding: 10px 0px 25px;
  gap: 10px;
  img {
    width: 48px;
    height: 48px;
  }
  p {
    margin: 0px;
    font-size: 20px;
    font-weight: 700;
    color: var(--black-color);
  }
  span {
    color: #717171;
    font-weight: 400;
    font-size: 16px;
  }
}
.faqItem_D9e_D:first-child {
  flex: 0.3 1;
}
.faqItem_D9e_D:last-child {
  border-bottom: 1px solid transparent;
}


.switch_lNQ36 {
  display: none;
}





input:checked + .switchLabel_eAgQ3 {
  background: var(--_16c098-color);
}

input:checked + .switchLabel_eAgQ3:after {
  transform: translateX(20px);
}

.button_N0s8g {
  text-decoration: underline;
  font-weight: 600;
}



.filterSort_wm2VX {
  font-weight: 300;
  color: var(--black-color);
  padding: 0px 16px;
  width: 100%;
  height: 48px;
  min-height: 48px;
  border-radius: 4px;
  border: 1px solid #bdbdbd;
  display: flex;
  align-items: center;
  font-size: 11px;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
}

.filterSort_wm2VX b {
  font-weight: 400;
  font-size: 15px;
  margin-right: 6px;
}

.chevronIcon_TL4_Y {
  margin-left: auto;
  color: #09121f;
}

.dropdownOptions_Uo0es {
  position: absolute;
  top: calc(100% - 2px);
  left: 0;
  width: 100%;
  background: var(--white-background);
  border: 1px solid #bdbdbd;
  margin-top: 4px;
  border-radius: 4px;
  box-shadow: 0px 4px 8px var(--_0000001a-shadow);
  z-index: 1000;
  overflow: hidden;
}

.dropdownOption_N8xPt {
  margin: 0px 12px;
  padding: 14px 0px;
  font-size: 12px;
  border-bottom: 1px solid #bdbdbd;
  font-weight: 500;
  color: #131313;
  cursor: pointer;
  transition: background-color 0.2s;
}


.title_Az1bb {
  font-size: 16px;
  font-weight: 600;
  color: var(--black-color);
  margin-bottom: 16px;
}



.inputGroup_IM1jm {
  display: flex;
  align-items: center;
  gap: 16px;
}

.inputGroup_IM1jm{
  input {
    width: 100%;
  }
}

.inputWrapper_KVql9 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 4px;
}






.tagsContent_YDswX {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  flex: 1 1;
}

.icon_PxziN {
  width: 24px;
  height: 24px;
}

label {
  font-size: 14px;
  font-weight: 400;
  color: #717171;
}
.signInButton_WuSVV {
  width: 100%;
  padding: 0px 12px;
  margin-top: 15px;
  background-color: #162d3a;
  color: var(--white-background);
  font-size: 20px;
  height: 52px;
  font-weight: 400;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.input_zwUta {
  border: none;
  border-bottom: 1px solid #e9e9e9;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: #717171;
  padding: 4px 0;
}
.inputEdit_Y68eb {
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  width: max-content;
  color: #717171;
  width: 100%;
  border-radius: 10px;
    padding: 14px 8px;
}


.input_zwUta::placeholder {
  color: #c4c4c4;
}
.inputEdit_Y68eb::placeholder {
  color: #c4c4c4;
}

.bgModal_CcQYK {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--_00000020-background);
  z-index: 99;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/AccountSettings/AccountSettings.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB;IACE,cAAc;IACd,eAAe;IACf,WAAW;IACX;MACE,eAAe;MACf,yBAAiB;cAAjB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;;;;AAKA;;EAEE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;;;;;AAMA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAO;EACP,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,SAAS;EACT;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,WAAS;AACX;AACA;EACE,oCAAoC;AACtC;;;AAGA;EACE,aAAa;AACf;;;;;;AAMA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;;;AAIA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,QAAQ;AACV;;;;;;;AAOA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;IACjB,iBAAiB;AACrB;;;AAGA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,WAAW;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.container {\n  display: flex;\n  padding: 12px 14px;\n  font-family: \"Inter\", sans-serif;\n  background-color: var(--f6-background);\n  height: 80vh;\n  width: 80%;\n  max-width: 800px;\n  justify-content: space-between;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  overflow-y: scroll;\n  box-shadow: 0 4px 8px var(--_0000001a-shadow); \n  border-radius: 8px; \n  z-index: 999;\n  gap: 20px;\n  scrollbar-width: none; \n  -ms-overflow-style: none; \n  box-sizing: border-box;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.HeaderUserSetting {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .headerLeft {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    text-transform: capitalize;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .arrowGreen {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    padding: 4px;\n    cursor: pointer;\n    background-color: var(--_16c098-color);\n    border-radius: 5px;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n  }\n\n  .arrowHeaderGray {\n    height: 10px;\n    width: 10px;\n    transform: rotate(90deg);\n    -webkit-transform: rotate(90deg);\n    -moz-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n  }\n}\n\n.container::-webkit-scrollbar {\n  display: none; \n}\n.leftSection {\n  width: 30%;\n  height: fit-content;\n}\n\n.breadcrumb {\n  font-size: 14px;\n  color: #484848;\n  margin-bottom: 29px;\n  font-weight: 600;\n  gap: 20px;\n  display: flex;\n  align-items: center;\n  svg {\n    color: #767676;\n    font-size: 10px;\n    width: 10px;\n    span {\n      cursor: pointer;\n      user-select: none;\n    }\n  }\n}\n\n.detailsContainer {\n  margin-bottom: 24px;\n}\n\n.detailItem {\n  border-bottom: 1px solid #ebebeb;\n  padding: 12px 0px 12px;\n}\n\n\n\n\n.editButton,\n.addButton {\n  font-size: 12px;\n  color: var(--_16c098-color);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n\n\n\n\n.rightSection {\n  margin-bottom: 40px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  flex: 2;\n  width: 100%;\n  background-color: var(--white-color);\n  padding: 15px;\n  padding-top: 0;\n  box-sizing: border-box;\n  border: 1px solid var(--ececf1-border);\n  border-radius: 20px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n}\n\n.faqContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: 12px;\n  box-sizing: border-box;\n}\n\n.faqItem {\n  flex: 0.35;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #dddddd;\n  padding: 10px 0px 25px;\n  gap: 10px;\n  img {\n    width: 48px;\n    height: 48px;\n  }\n  p {\n    margin: 0px;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--black-color);\n  }\n  span {\n    color: #717171;\n    font-weight: 400;\n    font-size: 16px;\n  }\n}\n.faqItem:first-child {\n  flex: 0.3;\n}\n.faqItem:last-child {\n  border-bottom: 1px solid transparent;\n}\n\n\n.switch {\n  display: none;\n}\n\n\n\n\n\ninput:checked + .switchLabel {\n  background: var(--_16c098-color);\n}\n\ninput:checked + .switchLabel:after {\n  transform: translateX(20px);\n}\n\n.button {\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n\n\n.filterSort {\n  font-weight: 300;\n  color: var(--black-color);\n  padding: 0px 16px;\n  width: 100%;\n  height: 48px;\n  min-height: 48px;\n  border-radius: 4px;\n  border: 1px solid #bdbdbd;\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  justify-content: flex-start;\n  cursor: pointer;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.filterSort b {\n  font-weight: 400;\n  font-size: 15px;\n  margin-right: 6px;\n}\n\n.chevronIcon {\n  margin-left: auto;\n  color: #09121f;\n}\n\n.dropdownOptions {\n  position: absolute;\n  top: calc(100% - 2px);\n  left: 0;\n  width: 100%;\n  background: var(--white-background);\n  border: 1px solid #bdbdbd;\n  margin-top: 4px;\n  border-radius: 4px;\n  box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.dropdownOption {\n  margin: 0px 12px;\n  padding: 14px 0px;\n  font-size: 12px;\n  border-bottom: 1px solid #bdbdbd;\n  font-weight: 500;\n  color: #131313;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n\n.title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--black-color);\n  margin-bottom: 16px;\n}\n\n\n\n.inputGroup {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.inputGroup{\n  input {\n    width: 100%;\n  }\n}\n\n.inputWrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 4px;\n}\n\n\n\n\n\n\n.tagsContent {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n  flex: 1;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n}\n\nlabel {\n  font-size: 14px;\n  font-weight: 400;\n  color: #717171;\n}\n.signInButton {\n  width: 100%;\n  padding: 0px 12px;\n  margin-top: 15px;\n  background-color: #162d3a;\n  color: var(--white-background);\n  font-size: 20px;\n  height: 52px;\n  font-weight: 400;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n.input {\n  border: none;\n  border-bottom: 1px solid #e9e9e9;\n  outline: none;\n  font-size: 14px;\n  font-weight: 400;\n  color: #717171;\n  padding: 4px 0;\n}\n.inputEdit {\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-weight: 400;\n  width: max-content;\n  color: #717171;\n  width: 100%;\n  border-radius: 10px;\n    padding: 14px 8px;\n}\n\n\n.input::placeholder {\n  color: #c4c4c4;\n}\n.inputEdit::placeholder {\n  color: #c4c4c4;\n}\n\n.bgModal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--_00000020-background);\n  z-index: 99;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_yngAo`,
	"HeaderUserSetting": `HeaderUserSetting_yfD9t`,
	"headerLeft": `headerLeft_AvIqO`,
	"arrowGreen": `arrowGreen_obSOR`,
	"arrowHeaderGray": `arrowHeaderGray_Q3wSX`,
	"leftSection": `leftSection_lb85o`,
	"breadcrumb": `breadcrumb_BI21A`,
	"detailsContainer": `detailsContainer_trL5e`,
	"detailItem": `detailItem_NN4B4`,
	"editButton": `editButton_DJR9F`,
	"addButton": `addButton_thnAO`,
	"rightSection": `rightSection_NE3fW`,
	"faqContainer": `faqContainer_bLtN9`,
	"faqItem": `faqItem_D9e_D`,
	"switch": `switch_lNQ36`,
	"switchLabel": `switchLabel_eAgQ3`,
	"button": `button_N0s8g`,
	"filterSort": `filterSort_wm2VX`,
	"chevronIcon": `chevronIcon_TL4_Y`,
	"dropdownOptions": `dropdownOptions_Uo0es`,
	"dropdownOption": `dropdownOption_N8xPt`,
	"title": `title_Az1bb`,
	"inputGroup": `inputGroup_IM1jm`,
	"inputWrapper": `inputWrapper_KVql9`,
	"tagsContent": `tagsContent_YDswX`,
	"icon": `icon_PxziN`,
	"signInButton": `signInButton_WuSVV`,
	"input": `input_zwUta`,
	"inputEdit": `inputEdit_Y68eb`,
	"bgModal": `bgModal_CcQYK`
};
export default ___CSS_LOADER_EXPORT___;
